import { IApplicationData } from "./common";
export class LLM implements IApplicationData {
  constructor() {
    this.name = "LLMs";
    this.text = "";
    this.prompt = "";
    this.attribute = "";
    this.model = "gpt";
    this.temperature = 0.3;
    this.multipleCase = true;
    this.transition = true;
    this.isRequired = true;
    this.checkFields = false;
    this.topP = 1;
    this.frequencyPenalty = 0;
    this.presencePenalty = 0;
    this.topK = 3;
    this.similarityCutOff = 50;
    this.numberOutput = 512;
    this.replyType = "default";
    this.userResponse = "";
    this.sentiment = "";
    this.entityAttribute = "";
    this.llmModel = "gpt-4o-mini";
  }
  name: string;
  text: string;
  prompt: string;
  attribute: string;
  model: string;
  multipleCase: boolean;
  transition: boolean;
  isRequired: boolean;
  checkFields: boolean;
  temperature: number;
  entityAttribute: string;
  topP: number;
  frequencyPenalty: number;
  presencePenalty: number;
  topK: number;
  similarityCutOff: number;
  replyType: string;
  numberOutput: number;
  userResponse: string;
  llmModel: string;
  sentiment: string;
}
